/* Dhrohar 0.6.0: mobile menu inline accordion (owner workbook D13–D19).
   Each parent link in the menu drawer is a <button aria-expanded aria-controls> followed by its child list.
   A tap (or Enter/Space) shows or hides the children directly underneath; the other main items stay in place.
   Markup: snippets/header-drawer.liquid. Dawn's MenuDrawer ignores .dh-acc__toggle (assets/global.js). */
(() => {
  if (window.DhroharMenuAccordion) return;
  window.DhroharMenuAccordion = true;

  const panelFor = (toggle) => document.getElementById(toggle.getAttribute('aria-controls'));

  const setOpen = (toggle, open) => {
    const panel = panelFor(toggle);
    if (!panel) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (!open) {
      // Collapsing a parent also collapses anything nested inside it.
      panel.querySelectorAll('.dh-acc__toggle[aria-expanded="true"]').forEach((child) => setOpen(child, false));
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest && event.target.closest('header-drawer .dh-acc__toggle');
    if (!toggle) return;
    event.preventDefault();
    setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    // Keep the newly shown children in view inside the scrolling drawer.
    if (toggle.getAttribute('aria-expanded') === 'true') {
      const panel = panelFor(toggle);
      const last = panel && panel.lastElementChild;
      if (last && last.scrollIntoView) last.scrollIntoView({ block: 'nearest' });
    }
  });

  // Escape on an expanded toggle collapses it first; a second Escape reaches Dawn and closes the drawer.
  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key !== 'Escape') return;
      const toggle = event.target.closest && event.target.closest('header-drawer .dh-acc__toggle[aria-expanded="true"]');
      if (!toggle) return;
      event.stopPropagation();
      setOpen(toggle, false);
    },
    true
  );
})();
